<template>
  <div :class="['section_header', {'mb-0': noBottomMargin}]">
    <div class="section_header--top">
      <div>
        <h3 v-if="title" class="section_header--title text-uppercase">{{ title }}</h3>
        <slot></slot>
      </div>

      <div class="flex">
        <slot name="right"></slot>
      </div>
    </div>

    <div v-if="description" class="section_header--bottom">
      <p class="section_header--description">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionHeader",
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    noBottomMargin: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.section_header {
  margin-bottom: 10px;

  &--top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &--title {
    font-size: 20px;
    padding: 0 0.75rem;
    line-height: 30px; // match is-small button height
  }

  &--bottom {
    margin-top: 6px;
    padding: 0 0.75rem;
  }

  &--description {
    max-width: 600px;
    font-size: 0.875rem;
    color: $text-muted;
    line-height: 1.3;
  }
}

.is-danger {
  .section_header {
    &--description {
      color: $danger;
    }
  }
}

</style>
